import { ArrowDown, ArrowUp, Trash2 } from 'lucide-react'
import { useEditorState, type Editor } from '@tiptap/react'

import { Button } from '@/components/ui/button'
import { messages } from '@/lib/messages'

import { blockState, moveBlock, removeBlock } from './block-actions'

const t = messages.documents.runs.edit.block

/** İmlecin bulunduğu üst düzey bloğu siler ya da yukarı/aşağı taşır (kopyada blok düzeyi düzenleme). */
export function RunBlockActions({ editor }: { editor: Editor }) {
  const state = useEditorState({ editor, selector: ({ editor: current }) => blockState(current) })
  const actions = [
    {
      label: t.moveUp,
      icon: <ArrowUp />,
      disabled: !state.canMoveUp,
      run: () => moveBlock(editor, 'up'),
    },
    {
      label: t.moveDown,
      icon: <ArrowDown />,
      disabled: !state.canMoveDown,
      run: () => moveBlock(editor, 'down'),
    },
    {
      label: t.remove,
      icon: <Trash2 />,
      disabled: !state.canRemove,
      run: () => removeBlock(editor),
    },
  ]
  return (
    <div role="group" aria-label={t.group} className="ml-auto flex items-center gap-1">
      {actions.map((action) => (
        <Button
          key={action.label}
          type="button"
          variant="ghost"
          size="icon-sm"
          aria-label={action.label}
          title={action.label}
          disabled={action.disabled}
          // Düğme odağı çalmasın: seçim editörde kalır.
          onMouseDown={(event) => event.preventDefault()}
          onClick={action.run}
        >
          {action.icon}
        </Button>
      ))}
    </div>
  )
}
